<template>
    <b-form-group
        :label="this.$t('presets')"
        label-for="presets"
        :label-cols="2"
        :description="(this.presets < 1) ? this.$t('noPresets') : ''"
        :horizontal="true">
        <div class="form-actions">
            <b-button type="submit" variant="primary" v-b-toggle.presets-sidebar
            :disabled="this.presets < 1" >{{ $t('edit') }}</b-button>

        </div>

        <b-sidebar id="presets-sidebar" title="Presets" shadow="lg" right width="30%">
            <div class="px-3 py-2">
                <b-form-group
                    :label="this.$t('Preset')"
                    label-for="preset"
                    :label-cols="2"
                    :horizontal="true">
                <b-select v-model="selected" :options="presets" />
                </b-form-group>

                <br />

                <b-card-body v-if="selected != ''">
                    <b-form-group
                        :label="this.$t('roles')"
                        label-for="roles"
                        description=""
                        :label-cols="2"
                        :horizontal="true">

                        <b-select v-model="selectedRoles" :options="roles"  :multiple="true" v-if="roles.length > 0" />
                        <span v-else>{{ $t('noAvailableRoles') }}</span>

                    </b-form-group>
                </b-card-body>
            </div>
        </b-sidebar>
    </b-form-group>
</template>
<script>
export default {
    components: {},
    props: {
        value: {
            type: Array,
            default: []
        }
    },
    data: function() {
        return {
            selected: '',
            roles: []
        }
    },
    computed: {
        presets() {
            if (!this.value) return []

            return this.value.map(p => {
                return {
                    value: p.name,
                    text: p.name
                }
            }).filter(f => {
                return f.value != "Default"
            })
        },

        preset: {
            get() {
                if (this.value) {
                    return this.value.find(p => {
                        return p.name == this.selected
                    })
                }

                return {}
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        selectedRoles: {
            get() {
                let { roles = [] } = this.preset

                return roles || []
            },

            set(val) {
                this.preset.roles = val
            }
        }
    },
    methods: {
        formatPresetName(name) {
            return name.replaceAll(" ", "").toLowerCase()
        }
    },

    mounted() {
        if (this.value && this.value.length > 0) {
            this.selected = this.value[0].name
        }

        this.$store.dispatch("fetchRoles").then(resp => {
            this.roles = resp.map(d => {
                return {
                    value: d.uuid,
                    text: d.name
                }
            })
        })

    }
}
</script>
